import { Menu } from 'antd'
import H from 'history'
import React, { FC } from 'react'
import { Link, RouteComponentProps, withRouter } from 'react-router-dom'

import { Theme } from '../../types'
import logo from '../../assets/Logo.png'
import styles from './index.module.less'
import { useAuth } from '../../providers/AuthProvider'

interface SystemMenuProps {
	location: H.Location
	theme: Theme
	onSelect?(): void
}

interface MenuItem {
	path: string
	title: string | React.ReactNode
	permissions: string[]
}

const SystemMenu: FC<SystemMenuProps> = ({ location, theme, onSelect }) => {
	const { userHasPermission, userHasManyServiceProviders } = useAuth()
	const [, selectedKey] = location.pathname.split('/')
	const menuItems: MenuItem[] = [
		{ title: 'Service Providers', path: '/serviceprovider', permissions: ['ServiceProvider.All.ReadWrite'] },
		{ title: 'Resellers', path: '/reseller', permissions: ['Reseller.All.ReadWrite', 'Reseller.Self.ReadWrite', 'Reseller.Self.Read'] },
		{ title: 'End Customers', path: '/endcustomer', permissions: ['Reseller.All.ReadWrite', 'Reseller.Self.ReadWrite', 'Reseller.Self.Read'] },
		{ title: 'Invites', path: '/invites', permissions: ['User.All.ReadWrite'] },
		{ title: 'Users', path: '/users', permissions: ['User.All.ReadWrite'] },
		{ title: 'API Tokens', path: '/api-tokens', permissions: ['ExternalAPI.All.Access'] }
	]

	return (
		<Menu selectedKeys={[`/${selectedKey}`]} theme={theme} mode='inline' onSelect={onSelect}>
			<div className={styles.header}>
				<Link to='/'>
					<div className={styles['app-logo']}>
						<img src={logo} alt='Akixi' />
					</div>
				</Link>
			</div>
			{menuItems
				.filter(item => {
					if (item.path === '/serviceprovider' && !userHasPermission(item.permissions)) {
						return userHasManyServiceProviders
					}
					return userHasPermission(item.permissions)
				})
				.map(item => {
					return (
						<Menu.Item className={styles.menuItem} key={item.path}>
							<Link to={item.path}>{item.title}</Link>
						</Menu.Item>
					)
				})}
		</Menu>
	)
}

const SystemMenuWithRouter = withRouter<SystemMenuProps & RouteComponentProps, React.FC<SystemMenuProps>>(SystemMenu)

export default SystemMenuWithRouter
